export default "__VITE_ASSET__DwWWZ3Hk__"